// Фоновые изображения
import bgMobile from './bg-gameplay.jpg'
import bgDesktop from './bg-desktop.webp'
import preloaderBg from './preloader-bg.png'

// Фон японской комнаты для ПК версии = bg-desktop.webp
const bgDesktopRoom = bgDesktop

export {
  bgMobile,
  bgDesktop,
  bgDesktopRoom,
  preloaderBg,
}

// Утилита для выбора фона в зависимости от устройства
export const getBackground = (isMobile: boolean) => {
  return isMobile ? bgMobile : bgDesktop
}


